export const MaterialIcon = ({ name, filled = false, weight = 400, grade = 0, size = 24, className = "", style, ...props }) => {
  const opsz = Math.min(48, Math.max(20, size));
  return (
    <span
      className={`material-symbols-rounded ${className}`}
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opsz}`,
        ...style,
      }}
      aria-hidden="true"
      {...props}
    >
      {name}
    </span>
  );
};
